<template>
    <div class="container">
        <vue-headful title="ABL Groupe | HOESCH" />
        <h2>HOESCH</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../../assets/images/ziehbankh.jpg')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Profilés spéciaux en aciers étirés à froid</h3>
                        <div>
                            <div>
                                <p>Profilés s'inscrivant dans un diamètre de 200 mm max. ou sections planes jusqu’à 300 mm de largeur. </p>
                            </div>
                            <div>
                                <p>Epaisseur : 4 mm mini.</p>
                            </div>
                            <div>
                                <p>Longueur : 11 m maxi.</p>
                            </div>
                            <div>
                                <p>Poids / mètre : 1,5 à 120 kg</p>
                            </div>
                        </div>
                        <h3>Cold drawn steel special profiles </h3>
                        <div>
                            <p>Profiles designed within a circle of 200 mm maximum. Flat shapes up to 300 mm width.</p>
                        </div>
                        <div>
                            <p>Thickness : 4 mm mini.</p>
                        </div>
                        <div>
                            <p>Length : 11 m maxi.</p>
                        </div>
                        <div>
                            <p>Weight / meter : 1,5 to 120 kg</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "HoeschColddrawn"
    }
</script>

<style scoped>

</style>